import Page from '@admin/components/page'
import Enrollments from './enrollments'
import Performance from './performance'
import Overview from './overview'
import Emails from './emails'
import Design from './design'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.workflow.title,
  manager: {
    path: `/admin/automation/workflows/${resources.workflow.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview workflow={ resources.workflow } />
      },
      {
        label: 't(Design)',
        path: '/design',
        panel: <Design workflow={ resources.workflow } />
      },
      {
        label: 't(Emails)',
        path: '/emails',
        panel: <Emails workflow={ resources.workflow } />
      },
      {
        label: 't(Enrollments)',
        path: '/enrollments',
        panel: <Enrollments workflow={ resources.workflow } />
      },
      {
        label: 't(Performance)',
        path: '/performance',
        panel: <Performance workflow={ resources.workflow } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  workflow: `/api/admin/automation/workflows/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
